import bettingBuddyLogo from 'assets/images/betting-buddy-logo.svg';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import Preloader from '../../../components/common/Preloader';
import Header from '../../../components/layout/Header';
import Page from '../../../components/layout/Page';
import { hasSavedSlips, getMobileNumber } from '../../../modules/account/selectors';
import { getPathname } from '../../../modules/app/selectors';
import { isAuthenticated } from '../../../modules/user/selectors';
import { BETTING_BUDDY, SAVED_SLIPS } from '../../../routes/paths';
import { collapse, expand } from '../../../utils/transition';
import HeaderMenuButton from '../../common/HeaderMenuButton';
import { savedSlipsHide, savedSlipsShow } from '../actions';
import Events from '../Events';
import NewSlip from '../NewSlip';
import NewSlipWidget from '../NewSlipWidget';
import SavedSlips from '../SavedSlips';
import { hasCurrentSlip, isSlipSavePending } from '../selectors';
import { logOut } from '../../../modules/auth/actions';
import checkBlocked from '../../../utils/checkBlocked';

export class BettingBuddyPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.contentNode = null;
    this.state = {
      newSlipExpanded: false
    };
  }

  toggle() {
    const { newSlipExpanded } = this.state;

    this.setState({ newSlipExpanded: !newSlipExpanded });
    if (newSlipExpanded) {
      collapse(this, 'betting-buddy-page__new-slip--expanded');
    } else {
      expand(this, 'betting-buddy-page__new-slip--expanded');
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.hasNewSlip && state.newSlipExpanded) {
      return {
        newSlipExpanded: false
      };
    }
    return null;
  }

  render() {
    const {
      path,
      userAuthenticated,
      slipSavePending,
      hasNewSlip,
      showSavedSlips,
      hideSavedSlips,
      shouldRenderSavedSlips,
      logOutAction,
      mobileNumber
    } = this.props;
    const { newSlipExpanded } = this.state;

    const isSavedSlipsPage = path === SAVED_SLIPS;
    const showCurrentSlip = !isSavedSlipsPage && hasNewSlip;
    const savedSlipsButtonClass = classnames('button--small', {
      'button--inverted': !isSavedSlipsPage
    });
    const currentSlipContainerClass = classnames('betting-buddy-page__new-slip', {
      'betting-buddy-page__new-slip--expanded': newSlipExpanded
    });
    checkBlocked(mobileNumber, logOutAction);

    return (
      <div className="betting-buddy-page">
        <div className="betting-buddy-page__main">
          <Page
            header={(
              <Header
                left={() => (
                  <HeaderMenuButton />
                )}
                center={() => (
                  <img
                    className="header__logo"
                    src={bettingBuddyLogo}
                    role="presentation"
                  />
                )}
                right={() => userAuthenticated && shouldRenderSavedSlips && (
                  <div className="header-button--right">
                    <Button
                      onClick={isSavedSlipsPage ? hideSavedSlips : showSavedSlips}
                      className={savedSlipsButtonClass}
                    >
                      Saved Slips
                    </Button>
                  </div>
                )}
              />
            )}
            main={isSavedSlipsPage ? <SavedSlips /> : <Events />}
          />
          {showCurrentSlip && (
            <div
              className={currentSlipContainerClass}
              ref={ref => {
                this.contentNode = ref;
              }}
            >
              <NewSlip />
            </div>
          )}
        </div>
        {showCurrentSlip && (
          <div className="betting-buddy-page__widget">
            <NewSlipWidget
              expanded={newSlipExpanded}
              onViewSlip={this.toggle}
              onCloseSlip={this.toggle}
            />
          </div>
        )}
        {slipSavePending && (
          <div className="page__overlay">
            <Preloader darkBackground>Saving Slip ...</Preloader>
          </div>
        )}
      </div>
    );
  }
}

BettingBuddyPage.propTypes = {
  path: PropTypes.string,
  userAuthenticated: PropTypes.bool,
  slipSavePending: PropTypes.bool,
  hasNewSlip: PropTypes.bool,
  showSavedSlips: PropTypes.func,
  hideSavedSlips: PropTypes.func,
  shouldRenderSavedSlips: PropTypes.bool,
  logOutAction: PropTypes.func,
  mobileNumber: PropTypes.string
};

BettingBuddyPage.defaultProps = {
  path: BETTING_BUDDY,
  userAuthenticated: false,
  slipSavePending: false,
  hasNewSlip: false,
  showSavedSlips: () => {
  },
  hideSavedSlips: () => {
  },
  shouldRenderSavedSlips: false
};

const mapStateToProps = state => ({
  path: getPathname(state),
  userAuthenticated: isAuthenticated(state),
  slipSavePending: isSlipSavePending(state),
  hasNewSlip: hasCurrentSlip(state),
  shouldRenderSavedSlips: hasSavedSlips(state),
  mobileNumber: getMobileNumber(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showSavedSlips: () => {
    dispatch(savedSlipsShow());
    ownProps.history.push(SAVED_SLIPS);
  },
  hideSavedSlips: () => {
    dispatch(savedSlipsHide());
    ownProps.history.push(BETTING_BUDDY);
  },
  logOutAction: () => {
    dispatch(logOut());
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BettingBuddyPage)
);
